import { Card, Group, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { TenantCardHeader } from './TenantCardHeader';

type TenantCardErrorProps = {
  companyName: string;
};

export const TenantCardError = ({ companyName }: TenantCardErrorProps) => {
  const { t } = useTranslation();

  return (
    <Card component="li" aria-label={companyName} withBorder radius="lg" padding="lg">
      <TenantCardHeader companyName={companyName} />

      <Group gap={8} wrap="nowrap">
        <IconAlertTriangle size={16} stroke={1.7} color="var(--mantine-color-gray-5)" />
        <Text fz={13} c="gray.6">
          {t(i18nKeys.GROUP.COUNTS_UNAVAILABLE)}
        </Text>
      </Group>
    </Card>
  );
};
